import * as queryString from "lib/queryString/queryString";

/**
 * A basket to store the user global variables as user id, language, etc.
 */
export class SislogUserGlobals {
    public country: string;
    public appEnvironment: object = {};
    private _language: string;
    private langSet = false;
    private defaultLanguage: string;

    public appendUrlParams(sourceUrl: string): string {
        let urlParams = this.dash();
        if (sourceUrl.includes("?")) {
            return sourceUrl + "&" + urlParams;
        } else {
            return sourceUrl + "?" + urlParams;
        }
    }
    public mergeEnvironment(o: object): object {
        return { ...o, appEnvironment: { ...this.appEnvironment, language: this.language } };
    }

    public reset(): void {
        sislogUserGlobals.language = this.defaultLanguage;
        this.langSet = false;
        this.country = undefined;
        this.appEnvironment = {};
    }

    public get language() {
        return this._language;
    }

    public set language(l) {
        // TODO: use language variants
        if (this.defaultLanguage == null) {
            this.defaultLanguage = l;
        } else {
            this.langSet = true;
        }
        this._language = l;
        if (l === "vf" || l === "on") {
            this._language = "es";
        }
    }

    public get languageSet() {
        return this.langSet;
    }

    public stringify() {
        return queryString.stringify({ language: this.language, appEnvironment: this.appEnvironment });
    }
    public dash() {
        return queryString.stringify({ appEnvironment: { language: this.language, ...this.appEnvironment } });
    }

    public get locale() {
        //TODO: devolver con el sufijo el pais, pdte de modificar
        //Pdte contemplar el pais en la app
        switch (this.language) {
            case "es":
                return this.language + "-ES";
            case "en":
                return this.language + "-GB";
            case "pt":
                return this.language + "-PT";
            case "fr":
                return this.language + "-FR";
            default:
                return this.language + "-ES";
        }
    }
}

let sislogUserGlobals = new SislogUserGlobals();
export default sislogUserGlobals;
